import { useEffect, useState, useCallback } from "react";
import axiosClient from "./axiosClient";
import { pickBy, identity } from "lodash";

const useCallApiUrl = (url, options, enable = true) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(enable);
    const [error, setError] = useState(null);
    const [reloadIndex, setReloadIndex] = useState(0);

    const reload = () => setReloadIndex((prev) => prev + 1);

    const fetchData = useCallback(async () => {
        if (!enable || !url) return;

        setLoading(true);
        setError(null);
        const optsCleaned = pickBy(options, (value) => value !== undefined && value !== null && value !== "");
        try {
            const response = await axiosClient.get(url, { params: optsCleaned });
            setData(response);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url, options, enable, reloadIndex]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return { data, loading, error, reload };
};

export default useCallApiUrl;
